var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.937.085.576 2.023A.97.97 0 0 0 0 2.909V15.03a.97.97 0 0 0 1.364.886l4.006-1.78 4.96 1.804a1 1 0 0 0 .33.06 1 1 0 0 0 .406-.086l4.358-1.937a.97.97 0 0 0 .576-.886V.97a.97.97 0 0 0-1.364-.886l-4.006 1.78L5.67.06a.97.97 0 0 0-.733.025m6.7 13.453V3.54l2.424-1.077v9.999zm-1.94-9.95L6.303 2.354v10.058l3.394 1.234zM1.939 3.54v10l2.425-1.078v-10z",
    clipRule: "evenodd"
  })));
};
export default SvgMap;